import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="5"
    height="4"
    viewBox="0 0 5 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.357384 0.5H4.64262C4.71329 0.499938 4.78238 0.523362 4.84116 0.567307C4.89994 0.611251 4.94575 0.673741 4.9728 0.746865C4.99985 0.819988 5.00693 0.900457 4.99312 0.978085C4.97932 1.05571 4.94526 1.12701 4.89527 1.18295L2.75265 3.58276C2.71949 3.61995 2.6801 3.64945 2.63675 3.66957C2.5934 3.6897 2.54693 3.70006 2.5 3.70006C2.45307 3.70006 2.4066 3.6897 2.36325 3.66957C2.3199 3.64945 2.28051 3.61995 2.24735 3.58276L0.104734 1.18295C0.0547352 1.12701 0.0206793 1.05571 0.00687718 0.978085C-0.00692498 0.900457 0.000147304 0.819988 0.0271987 0.746865C0.0542501 0.673741 0.100064 0.611251 0.158841 0.567307C0.217618 0.523362 0.286715 0.499938 0.357384 0.5Z"
      fill="currentColor"
      fillOpacity="0.6"
    />
  </svg>
);
export default SvgArrowDown;
